module.exports = __webpack_public_path__ + "static/img/weixin.72b42b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin.png
// module id = q0uv
// module chunks = 0